export enum ExportTypeEnum {
    Pdf= 10,
    Ppt = 11,
}